import Vue from 'vue'
import VueRouter from 'vue-router'
import main from './main.vue'

Vue.use(VueRouter)

let routes = [
	{
		name:'home',
		path:'/',
		component: () => import('./pages/home.vue')
	}
	/*
	,{
		name:'auth',
		path:'/auth',
		component: () => import('./pages/auth.vue')
	}
	*/
]

const router = new VueRouter({routes, mode: 'history'})
new Vue({
  router,
  render: h => h(main)
}).$mount('#app')


